/**
 * A download's file name, in the reader's language.
 *
 * Every export passed a hardcoded English slug ("ministry-types"), so a French user opened a fully French
 * dialog and found an English file name sitting in it — and saved a file their colleagues could not scan.
 * The name now comes from the same translated label the screen already shows.
 *
 * Accents are folded rather than dropped, because "Ministères" must not become "minist-res"; anything left
 * that is not a letter or digit collapses to a single hyphen.
 */
export function exportFileName(label: string, fallback = "export"): string {
  const slug = label
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60)
  return slug || fallback
}
